import { getLocaleSettings } from '../../i18n/settings';

export const MAINSITE = getLocaleSettings().mainSite;
